var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuy5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "buy 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.284 10.4018H9.8815C9.3333 10.4018 8.89474 9.96325 8.89474 9.41505C8.89474 8.86686 9.3333 8.4283 9.8815 8.4283H21.284C21.8322 8.4283 22.2707 8.86686 22.2707 9.41505C22.1611 9.96325 21.8322 10.4018 21.284 10.4018Z",
    fill: "#2CA07D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.0382 17.1977C22.819 15.7723 22.49 12.5928 22.2708 11.1675C22.1611 10.7289 21.8322 10.2904 21.284 10.2904H10.8683C9.77187 10.2904 9.00439 11.1675 9.00439 12.1542V17.8555V28.2712H32.6865V25.5302V22.7893C32.6865 22.1314 32.3576 21.4736 31.8094 21.1447C29.507 19.7194 26.5467 18.623 23.9154 18.0748C23.4768 17.9651 23.1479 17.6362 23.0382 17.1977Z",
    fill: "#54D4AE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.8322 16.4327L21.1744 11.7182C21.1744 11.4989 20.9551 11.2796 20.7358 11.2796H17.0081C16.7888 11.2796 16.5695 11.4989 16.5695 11.7182V16.4327C16.5695 16.6519 16.7888 16.8712 17.0081 16.8712H21.284C21.6129 16.9809 21.8322 16.7616 21.8322 16.4327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.1008 12.2665V16.5424C10.1008 16.7617 10.3201 16.981 10.5394 16.981H15.1442C15.3635 16.981 15.5828 16.7617 15.5828 16.5424V11.8279C15.5828 11.6087 15.3635 11.3894 15.1442 11.3894H10.9779C10.5394 11.2797 10.1008 11.7183 10.1008 12.2665Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33043 20.4757C8.75476 19.2888 10.6699 18.4424 12.7321 18.4424C17.0756 18.4424 20.6993 21.942 20.6993 26.4096C20.6993 26.8132 20.372 27.1405 19.9683 27.1405C19.5647 27.1405 19.2374 26.8132 19.2374 26.4096C19.2374 22.7638 16.2827 19.9043 12.7321 19.9043C11.0666 19.9043 9.4733 20.5929 8.26629 21.5987C7.95617 21.8572 7.49528 21.8153 7.23685 21.5052C6.97842 21.195 7.02032 20.7341 7.33043 20.4757Z",
    fill: "#2CA07D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.7321 32.9862C16.3652 32.9862 19.3105 30.041 19.3105 26.4078C19.3105 22.7747 16.3652 19.8295 12.7321 19.8295C9.09898 19.8295 6.15375 22.7747 6.15375 26.4078C6.15375 30.041 9.09898 32.9862 12.7321 32.9862Z",
    fill: "#232429"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.7321 30.246C14.8514 30.246 16.5695 28.528 16.5695 26.4086C16.5695 24.2893 14.8514 22.5713 12.7321 22.5713C10.6128 22.5713 8.89474 24.2893 8.89474 26.4086C8.89474 28.528 10.6128 30.246 12.7321 30.246Z",
    fill: "#898B94"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.996 26.6377C23.7435 24.1459 26.1038 22.2794 28.8491 22.2794C30.9829 22.2794 32.8498 23.4111 33.9592 25.1368C34.1775 25.4764 34.0792 25.9286 33.7396 26.1469C33.4 26.3652 32.9478 26.2669 32.7295 25.9273C31.8654 24.5831 30.4431 23.7413 28.8491 23.7413C26.7703 23.7413 24.9643 25.164 24.3962 27.0578C24.2802 27.4444 23.8727 27.6638 23.4861 27.5478C23.0994 27.4318 22.88 27.0243 22.996 26.6377Z",
    fill: "#2CA07D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28.8491 33.096C31.4528 33.096 33.5636 30.9852 33.5636 28.3815C33.5636 25.7777 31.4528 23.667 28.8491 23.667C26.2454 23.667 24.1346 25.7777 24.1346 28.3815C24.1346 30.9852 26.2454 33.096 28.8491 33.096Z",
    fill: "#232429"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.8491 30.246C29.8785 30.246 30.713 29.4115 30.713 28.3821C30.713 27.3527 29.8785 26.5183 28.8491 26.5183C27.8197 26.5183 26.9852 27.3527 26.9852 28.3821C26.9852 29.4115 27.8197 30.246 28.8491 30.246Z",
    fill: "#898B94"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy5);
export default __webpack_public_path__ + "static/media/buy5.8110feaa7277a3928ff4d2e5c4b5d66d.svg";
export { ForwardRef as ReactComponent };